module.exports = __webpack_public_path__ + "static/media/gen_was_man.c0712fab.png";